export const blogData = [
  {
    id: 0,
    title: "How To Get Started in the Tech Industry",
    introduction:
      "Most times when you ask people what the tech industry means, their answer has to do with the full name 'Technology' they're not wrong at all but there's a keyword missing there and that keyword is innovation, so,...",
    link: "https://mish-blog.hashnode.dev/how-to-get-started-in-the-tech-industry",
    imageSrc:
      "https://cdn.hashnode.com/res/hashnode/image/unsplash/gJUZjwy2EgE/upload/v1652457834244/biQjXu4O_.jpeg?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
  },
  {
    id: 1,
    title: "Everything You Need To Know About ARRAYS",
    introduction:
      "The array is the most common data structure in computer programming. Every programming language includes some form of array. Arrays are commonly used in computer programs to organize data so that a related set of values...",
    link: "https://mish-blog.hashnode.dev/what-are-arrays",
    imageSrc:
      "https://cdn.hashnode.com/res/hashnode/image/upload/v1657883442110/ROnFPHgdx.jpg?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
  },
  {
    id: 2,
    title: "Routing in NextJS",
    introduction:
      "One of the advantages of using the next.js react framework is because of its easy routing system which takes place without the use of a third-party library, instead routing in next.js is a file-based router which is....",
    link: "https://mish-blog.hashnode.dev/routing-in-nextjs",
    imageSrc:
      "https://cdn.hashnode.com/res/hashnode/image/upload/v1658535972130/2D26ZiY-i.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
  },
];
